import React, { useEffect, useState } from 'react';
import {
  INavbarItem,
  INavbarItemGenieAsk,
} from '@models/interfaces/navigation.interface';

// type guard function. because TypeScript does not infer the type accurately with the usual if condition
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function isGenieAskItem(props: any): props is INavbarItemGenieAsk {
  return 'unreadIcon' in props || 'unreadActiveIcon' in props;
}

const BottomNavbarItem = (props: INavbarItem | INavbarItemGenieAsk) => {
  let defaultIcon, activeIcon;

  const [genieaskUnread, setGenieaskUnread] = useState<string>('');

  const getUnreadItem = () => {
    const genieaskUnreadItem = localStorage.getItem('genieaskUnread');
    if (genieaskUnreadItem) {
      setGenieaskUnread(genieaskUnreadItem);
    }
  };

  useEffect(() => {
    getUnreadItem();
  }, []);

  // event listener to observe changes on localStorage
  window.addEventListener('storage', () => {
    getUnreadItem();
  });

  // icon shown will be based on the value of `genieaskUnread` localStorage key and props key existence
  defaultIcon =
    isGenieAskItem(props) && genieaskUnread != '0'
      ? props.unreadIcon
      : props.icon;
  activeIcon =
    isGenieAskItem(props) && genieaskUnread != '0'
      ? props.unreadActiveIcon
      : props.activeIcon;

  return (
    <div className={'text-center'}>
      <img
        src={props.selected ? activeIcon : defaultIcon}
        className={
          'md:mr-2 max-md:mx-auto max-md:block md:inline max-md:mb-1.5 md:mb-0 max-md:h-6'
        }
        alt="icon"
      />
      <span
        className={
          'font-bold text-xxs !leading-3 ' +
          (props.selected ? 'text-primary-skyblue' : 'text-neutral-eraser')
        }
      >
        {props.label}
      </span>
    </div>
  );
};

export default BottomNavbarItem;
